<template>
	<v-card class="mt-2" v-if="opportunity">
		<v-toolbar flat class="transparent">
			<div>
				<div class="headline">Excel Spreadsheet</div>
				<span class="grey--text">{{ opportunity.spreadsheet ? 'Pre-generated' : 'Real-time generation'}}</span>
			</div>

			<v-spacer />

			<v-btn small fab color="green" :href="opportunity.spreadsheetUrl" v-if="opportunity.spreadsheetUrl">
				<v-icon small>mdi-download</v-icon>
			</v-btn>
			<v-btn small :loading="loading" @click="toggle" color="yellow darken-4" v-if="opportunity.spreadsheet">
				<v-icon left small>mdi-nuke</v-icon>
				Switch to real-time
			</v-btn>
			<v-btn small :loading="loading" @click="toggle" v-if="!opportunity.spreadsheet">
				<v-icon left small>mdi-refresh</v-icon>
				Switch to pre-generation
			</v-btn>
		</v-toolbar>
	</v-card>
</template>

<script>
export default {
	created() {
	},
	data() {
		return {
			loading: false
		}
	},
	computed: {
		opportunity() {
			return this.$store.getters['admin/opportunities/find']()
		},
	},
	methods: {
		async toggle() {
			this.loading = true

			if (this.opportunity.spreadsheet) {
				await Vue.$http.delete(`admin/opportunities/${this.$route.params.id}/spreadsheet`)
			} else {
				await Vue.$http.post(`admin/opportunities/${this.$route.params.id}/spreadsheet`)
			}
			await this.$store.dispatch('admin/opportunities/fetch', this.$route.params.id)
			this.loading = false
		},
	},
}
</script>
